import React from "react";
import ReactPlayer from "react-player";

function HouseVideos() {
  return <ReactPlayer url="https://youtu.be/PH_fRs1-yZ8" width="100%" />;
}

export default HouseVideos;
